<div #selectcountry id="select-country" class="hidden overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-50 justify-center items-center md:inset-0 h-modal sm:h-full">
  <div class="flex min-w-full items-center md:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all min-w-full md:min-w-0 sm:my-8 sm:align-middle sm:p-6">
      <div>
        <div class="text-left">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title" i18n>Select your country</h3>
          <div class="mt-2">
            <p class="text-sm text-gray-500" i18n>Please select your current location</p>
          </div>
          <div class="mt-2">

            <div>
              <label id="listbox-label" class="block text-sm font-medium text-gray-700">Country</label>
              <div class="mt-1 relative">
                <button (click)="showCountryList()" id="dropdownButton" type="button" class="relative w-full bg-white border border-gray-300 rounded-md shadow pl-3 pr-10 py-2 text-left cursor-default focus:outline-none sm:text-sm" >
                  <span class="flex items-center">
                    <img src="/assets/icons/flags/{{selectedCountry.imageFile}}" alt="" class="flex-shrink-0 h-6 w-6 rounded-full" loading="lazy">
                    <span class="ml-3 block truncate"> {{selectedCountry.name}} <span *ngIf="selectedCountry.name != selectedCountry.native">({{selectedCountry.native}}) </span> </span>
                  </span>
                  <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <!-- Heroicon name: solid/selector -->
                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6">
        <button type="button" (click)="closePopup()" class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm" i18n="@@confirm-button">Confirm</button>
      </div>
    </div>
  </div>
</div>

<countriespopup [selectedCountryIsoCode]="selectedCountry" #countriesPopup></countriespopup>
